// Player state during a match

export type OpponentType = "bot" | "rec"; // bot or recorded ghost

export interface PlayerState {
  snow: number; // collected snow
  ammo: number; // snowballs packed in R2 and left to throw in R3
  perfectBalls: number; // how many of the ammo are PERFECT PACK balls
  hp: number; // health points
  throws: number; // total throws
  blocks: number;
  hits: number; // successful hits
  damageDealt: number; // total damage dealt
  // Dodge/block state (fields exist, behavior in TAP-199)
  dodgeCooldownUntil: number; // tick
  blockCooldownUntil: number; // tick
}

export function createPlayerState(maxHP: number): PlayerState {
  return {
    snow: 0,
    ammo: 0,
    perfectBalls: 0,
    hp: maxHP,
    throws: 0,
    hits: 0,
    blocks: 0,
    damageDealt: 0,
    dodgeCooldownUntil: 0,
    blockCooldownUntil: 0,
  };
}
